import React from 'react';
import { useHistory } from "react-router-dom";
import style from "./style.module.css"
import { Modal } from 'antd-mobile'

export default function(props){
    let route = useHistory();

    function backPage(){
       props.changeShow(false)
    }

    return (
        <div>
            <Modal
                className={style.register}
                visible={props.visible}
                popup={false}
                >
                    <div className={style.agreement}>
                        <div className={style.useInfo}>
                            <div className={style.title}>财学堂用户注册协议</div>
                            <div className={style.content}>
                                <div className={style.item_title}>一、服务条款的确认及接受</div>
                                    <p className={style.item}>
                                    1、财学堂教育文化传媒成都有限公司（以下称“财学堂”）官网（https://www.caixuetang.cn/）及财学堂客户端软件的各项电子服务的所有权和运作权归属于财学堂所有，财学堂提供的服务将完全按照其发布的服务条款和操作规则严格执行。您确认所有服务条款并完成注册程序时，本协议在您与财学堂之间成立并发生法律效力，同时您成为财学堂正式用户。
                                    </p>
                                    <p className={style.item}>
                                    2、根据国家法律法规变化及财学堂运营需要，财学堂有权对本协议条款及相关规则不时地进行修改，修改后的内容一旦以任何形式公布在财学堂上即生效，并取代此前相关内容，您应不时关注财学堂公告、提示信息及协议、规则等相关内容的变动。您知悉并确认，如您不同意更新后的内容，应立即停止使用财学堂；如您继续使用财学堂，即视为知悉变动内容并同意接受。
                                    </p>

                                <div className={style.item_title}>二、服务需知</div>
                                    <div className={style.item}>
                                        <div className={style.item_rule}>
                                            1、财学堂运用自身开发的操作系统通过国际互联网络为用户提供购买商品等服务。使用财学堂，您必须：
                                        </div>
                                        <ul className={style.item_content}>
                                            <li>(1)自行配备上网的所需设备，包括个人手机、平板电脑、调制解调器、路由器等设备；</li>
                                            <li>(2)自行负担个人上网所支付的与此服务有关的电话费用、网络费用等；</li>
                                            <li>(3)选择与所安装终端设备相匹配的软件版本，包括但不限于iOS、Android、等多个财学堂发布的应用版本。</li>
                                        </ul>
                                        <div className={style.item_rule}>
                                            2、基于财学堂所提供的网络服务的重要性，您确认并同意：
                                        </div>
                                        <ul className={style.item_content}>
                                            <li>(1)提供的注册资料真实、准确、完整、合法有效，注册资料如有变动的，应及时更新； </li>
                                            <li>(2)如果您提供的注册资料不合法、不真实、不准确、不详尽的，您需承担因此引起的相应责任及后果，并且财学堂保留终止您使用财学堂各项服务的权利。</li>
                                            
                                        </ul>
                                    </div>

                                <div className={style.item_title}>三、服务产品</div>
                                    <p className={style.item}>
                                        1、通过财学堂网站或财学堂客户端软件购买产品，包括但不限于第三方服务商提供的产品，您应具备购买相关产品的权利能力和行为能力，如果您在18周岁以下，您需要在父母或监护人的监护参与下才能使用财学堂。在下订单的同时，即视为您满足上述条件，并对您在订单中提供的所有信息的真实性负责
                                    </p>
                                    <p className={style.item}>
                                        2、您理解并同意：财学堂上销售展示的产品和价格等信息仅仅是要约邀请，您下单时须选择您希望购买的产品数量、价款及支付方式、联系方式等内容；您下单并支付货款后合同即成立。
                                    </p>

                                <div className={style.item_title}>四、用户个人信息保护及授权</div>
                                    <p className={style.item}>
                                        1、您知悉并同意，为方便您使用财学堂相关服务，财学堂将存储您在使用时的必要信息，包括但不限于您的真实姓名、性别、联系方式等信息。除您所购产品服务需要和法律法规规定的情形外，未经您的许可财学堂不会向第三方公开、透露您的个人信息。财学堂对相关信息采取专业加密存储与传输方式，利用合理措施保障用户个人信息的安全。
                                    </p>
                                    <p className={style.item}>
                                        2、您知悉并确认，您在注册帐号或使用财学堂的过程中，需要提供真实的身份信息，财学堂将根据国家法律法规相关要求，进行基于移动电话号码的真实身份信息认证。若您提供的信息不真实、不完整，则无法使用财学堂或在使用过程中受到限制，同时，由此产生的不利后果，由您自行承担。
                                    </p>
                                    <p className={style.item}>
                                        3、您在使用财学堂某一特定服务时，该服务可能会另有单独的协议、相关业务规则等（以下统称为“单独协议”），您在使用该项服务前请阅读并同意相关的单独协议；您使用前述特定服务，即视为您已阅读并同意接受相关单独协议。
                                    </p>
                                    <div className={style.item}>
                                        <div className={style.item_rule}>
                                        4、您充分理解并同意：
                                        </div>
                                        <ul className={style.item_content}>
                                            <li>(1)接收通过邮件、短信、电话等形式，向在财学堂注册、购物的用户发送财经、股市及新产品方面的信息和服务，用户将同意接受此类商业性电子信息，并不视上述行为为垃圾邮件或短信；</li>
                                            <li>(2)为配合行政监管机关、司法机关执行工作，在法律规定范围内财学堂有权向上述行政、司法机关提供您在使用财学堂时所储存的相关信息，包括但不限于您的注册信息等，或使用相关信息进行证据保全，包括但不限于公证、见证等；</li>
                                            <li>(3)财学堂依法保障您在安装或使用过程中的知情权和选择权，在您使用财学堂服务过程中，涉及您设备自带功能的服务会提前征得您同意，您一经确认，财学堂有权开启包括但不限于收集地理位置、读取通讯录、使用摄像头、启用录音等提供服务必要的辅助功能。</li>
                                            <li>(4)财学堂有权根据实际情况，在法律规定范围内自行决定单个用户在财学堂服务中数据的最长储存期限以及用户日志的储存期限，并在服务器上为其分配数据最大存储空间等。</li>
                                        </ul>
                                    </div>
                                
                                <div className={style.item_title}>五、用户行为规范</div>
                                    <div className={style.item}>
                                        <div className={style.item_rule}>
                                        1、本协议依据国家相关法律法规规章制定，您同意严格遵守以下义务：
                                        </div>
                                        <ul className={style.item_content}>
                                            <li>(1)不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；</li>
                                            <li>(2)从中国大陆向境外传输资料信息时必须符合中国有关法规；</li>
                                            <li>(3)不得利用财学堂从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；</li>
                                            <li>(4)不得干扰财学堂的正常运转，不得侵入财学堂及国家计算机信息系统；</li>
                                            <li>(5)不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料；</li>
                                            <li>(6)不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；</li>
                                            <li>(7)不得教唆他人从事本条所禁止的行为；</li>
                                            <li>(8)不得利用在财学堂注册的账户进行牟利性经营活动；</li>
                                            <li>(9)不得发布任何侵犯他人隐私、个人信息、著作权、商标权等知识产权或合法权利的内容。</li>
                                        </ul>
                                    </div>
                                    <p className={style.item}>
                                        2、您须对自己在网上的言论和行为承担法律责任，您若在财学堂上散布和传播反动、色情或其它违反国家法律的信息，财学堂的系统记录有可能作为您违反法律的证据。
                                    </p>
                                
                                <div className={style.item_title}>六、客户端软件使用规范</div>
                                    <div className={style.item}>
                                        <div className={style.item_rule}>
                                            1、关于客户端软件的获取与更新：
                                        </div>
                                        <ul className={style.item_content}>
                                            <li>(1)您可以直接从财学堂的网站上获取财学堂客户端软件，也可以从得到财学堂授权的第三方获取，如果您从未经财学堂授权的第三方获取财学堂客户端软件或与财学堂名称相同的安装程序，财学堂无法保证该软件能够正常使用，并对因此给您造成的损失不予负责；</li>
                                            <li>(2)为了改善用户体验、完善服务内容，财学堂将不断努力开发新的服务，并为您不时提供客户端软件更新，财学堂新版本发布后，旧版本的软件可能无法使用，财学堂不保证旧版财学堂软件继续可用及相应的客户服务，请您随时核对并下载最新版本。</li>
                                        </ul>
                                    </div>
                                    <div className={style.item}>
                                        <div className={style.item_rule}>
                                            2、除非法律允许或财学堂书面许可，您使用财学堂过程中不得从事下列行为：
                                        </div>
                                        <ul className={style.item_content}>
                                            <li>(1)删除财学堂软件及其副本上关于著作权的信息；</li>
                                            <li>(2)对财学堂软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现财学堂软件的源代码；</li>
                                            <li>(3)对财学堂拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</li>
                                            <li>(4)对财学堂运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及财学堂运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经财学堂授权的第三方工具/服务接入财学堂和相关系统；</li>
                                            <li>(5)通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；</li>
                                            <li>(6)通过非财学堂开发、授权的第三方软件、插件、外挂、系统，登录或使用财学堂软件及服务，或制作、发布、传播上述工具；</li>
                                            <li>(7)自行或者授权他人、第三方软件对财学堂及其组件、模块、数据进行干扰。</li>
                                        </ul>
                                    </div>

                                <div className={style.item_title}>七、违约责任</div>
                                    <p className={style.item}>
                                        1、如果财学堂发现或收到他人举报投诉您违反本协议约定的，财学堂有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规帐号处以包括但不限于警告、限制或禁止使用部分或全部功能、帐号封禁直至注销的处罚，并公告处理结果。
                                    </p>
                                    <p className={style.item}>
                                        2、财学堂有权依据合理判断对违反有关法律法规或本协议规定的行为采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，您应独自承担由此而产生的一切法律责任。
                                    </p>
                                    <p className={style.item}>
                                        3、您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；财学堂因此遭受损失的，您也应当一并赔偿。   
                                    </p>
                                    <p className={style.item}>
                                    4、除非另有明确的书面说明,财学堂不对财学堂网站或财学堂客户端软件的运营及其包含在上述载体的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的担保。   
                                    </p>

                                <div className={style.item_title}>八、所有权及知识产权</div>
                                    <p className={style.item}>
                                        1、您一旦接受本协议，即表明您主动将您在任何时间段在财学堂发表的任何形式的信息内容（包括但不限于客户评价、客户咨询、各类话题文章等信息内容）的财产性权利等任何可转让的权利，如著作权财产权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），全部独家且不可撤销地转让给财学堂所有，并且您同意财学堂有权就任何主体侵权而单独提起诉讼。
                                    </p>
                                    <p className={style.item}>
                                        2、本协议已经构成《中华人民共和国著作权法》第二十五条（条文序号依照2010年修订版《著作权法》确定）及相关法律规定的著作财产权等权利转让书面协议，其效力及于您在财学堂软件上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。
                                    </p>
                                    <p className={style.item}>
                                        3、您同意并已充分了解本协议的条款，承诺不将已发表于财学堂的信息，以任何形式发布或授权其它主体以任何方式使用（包括但不限于在各类网站、媒体上使用）。
                                    </p>
                                    <p className={style.item}>
                                        4、除法律另有强制性规定外，未经财学堂明确的特别书面许可,任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用财学堂的信息内容，否则，财学堂有权追究其法律责任。
                                    </p>
                                    <p className={style.item}>
                                        5、财学堂所刊登的资料信息（诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件），均是财学堂或其内容提供者的财产，受中国和国际版权法的保护。财学堂上所有内容的汇编是财学堂的排他财产，受中国和国际版权法的保护。财学堂上所有软件都是财学堂或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。
                                    </p>
                                
                                <div className={style.item_title}>九、特别说明</div>
                                    <p className={style.item}>
                                        1、第三方服务商在财学堂上展示的产品信息和广告宣传，包括产品服务、付款方式、及与广告有关的描述都只是第三方服务商单方行为。财学堂不承担任何责任，财学堂没有义务为这类产品服务、宣传信息和宣传行为负任何责任。
                                    </p>
                                    <p className={style.item}>
                                        2、股市有风险，入市须谨慎。财学堂刊载各种技术指标、图表、数据及提示信息等所有内容仅供参考，不应成为投资者买卖证券的依据，投资者如据此操作，风险自担，财学堂不承担任何经济和法律责任。
                                    </p>
                                    <p className={style.item}>
                                        3、财学堂网站或财学堂客户端软件页面展示信息的目的在于传播更多信息，与财学堂立场无关。财学堂不保证该信息(包括但不限于文字、视频、数据及图表)全部或者部分内容的准确性、真实性、完整性、有效性、及时性、原创性等。相关信息并未经过财学堂证实，不对您构成任何投资建议，据此操作，风险自担。
                                    </p>

                                <div className={style.item_title}>十、法律管辖适用及其他</div>
                                    <p className={style.item}>
                                        1、本协议的订立、执行和解释及争议的解决均应适用中国法律。如双方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向协议签订地人民法院提起诉讼。本协议签订地为中华人民共和国四川省成都市高新区。
                                    </p>
                                    <p className={style.item}>
                                        2、如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。
                                    </p>
                                    <p className={style.item}>
                                        3、本协议未明示授权的其他权利仍由财学堂保留，您在行使这些权利时须另外取得财学堂的书面许可。财学堂如果未行使前述任何权利，并不构成对该权利的放弃。
                                    </p>
                                    <p className={style.item}>
                                        4、本协议附件《财学堂隐私保护政策》作为本协议不可分割的组成部分，与本协议具有同等法律效力。
                                    </p>
                                <div className={style.infuse}>
                                    注：本协议内容请您仔细阅读，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。您点击“同意”按钮即视为您完全接受本协议。
                                </div>

                            </div>
                        </div>
                        <div className={style.agreeBtn} onClick={backPage}>
                            我已同意并阅读
                        </div>
                    </div>
                </Modal>
        </div>
        
    )
}